import FJStringUtil from '../../util/FJStringUtil.js';

class FJText {
    constructor(props = {}) {
        this._text = props.text || '';
        this._startTime = props.startTime || 0; // 单位s
        this._endTime = props.endTime || 0; // 单位s
        this._isDelete = props.isDelete || false;
        this._isSelected = false;
        this._isMatch = false;
        this._isHide = false;
        this._isMark = false;
        this._textBox = document.createElement('span');
        this._rect = null;
        this._content = null;
    }

    get text() {
        return this._text;
    }

    get startTime() {
        return this._startTime;
    }

    get endTime() {
        return this._endTime;
    }

    get duration() {
        return this._endTime - this._startTime;
    }

    get isDelete() {
        return this._isDelete;
    }

    set isDelete(value) {
        this._isDelete = value;
    }

    get isSelected() {
        return this._isSelected;
    }

    set isSelected(value) {
        this._isSelected = value;
    }

    get isMatch() {
        return this._isMatch;
    }

    set isMatch(value) {
        this._isMatch = value;
    }

    get isHide() {
        return this._isHide;
    }

    set isHide(value) {
        this._isHide = value;
    }

    get isMark() {
        return this._isMark;
    }

    set isMark(value) {
        this._isMark = value;
    }

    // 是否是一个段落的结尾
    isParagraphEnd() {
        const endWords = ['.', '!', '?', '。', '！', '？'];
        return this._text && endWords.find(word => this._text.endsWith(word));
    }

    isEmpty() {
        return !this._text;
    }

    // 是否point在文字范围内
    isInPoint(point) {
        if (this.isHide) return false;
        const rect = this.getRect();
        return (
            point.x >= rect.x && point.x <= rect.x + rect.width && point.y >= rect.y && point.y <= rect.y + rect.height
        );
    }

    // 匹配， isIntegrity为true则是完全匹配，否则为部分匹配
    isMatchText(text, isIntegrity = false) {
        if (!text) return false;
        if (isIntegrity) {
            const result = FJStringUtil.removePunctuation(this._text.trim().toLowerCase());
            return result === text.toLowerCase();
        } else {
            return this._text.trim().toLowerCase().indexOf(text.toLowerCase()) !== -1;
        }
    }

    getRect() {
        if (!this._content) return { x: 0, y: 0 };
        if (this._rect) return this._rect;
        const rect = this._textBox.getBoundingClientRect();
        const boxRect = this._content.getBoundingClientRect();
        const offset = this._content.scrollTop || 0;

        rect.x -= boxRect.x;
        rect.y = rect.y - boxRect.y + offset;
        this._rect = rect;
        return rect;
    }

    clearRect() {
        this._rect = null;
    }

    // 将内容写到content中
    render(content) {
        this._content = content;
        this.clearRect();
        if (this._text === '') {
            const time = (this._endTime - this._startTime).toFixed(2);
            this._textBox.innerHTML = `[...${time}s]`;
        } else {
            this._textBox.innerHTML = this._text;
        }

        if (!this._isHide) {
            content.appendChild(this._textBox);
        }
    }
    // 渲染特殊的临时高亮的情况
    renderHighLight(color = 'red') {
        this._textBox.style.backgroundColor = color;
    }
    // 渲染样式
    renderStyle() {
        // 设置背景颜色
        if (this._isSelected) {
            this._textBox.style.backgroundColor = 'rgba(0,87,255,0.25)';
        } else if (this._isMatch) {
            this._textBox.style.backgroundColor = 'rgba(0,255,43,0.25)';
        } else {
            this._textBox.style.backgroundColor = '';
        }
        // 设置文字颜色
        if (this._isDelete) {
            this._textBox.style.textDecoration = 'line-through';
            this._textBox.style.color = 'rgba(0,0,0,0.3)';
        } else {
            this._textBox.style.textDecoration = 'none';
            this._textBox.style.color = 'rgba(0,0,0,1)';
        }
    }

    destroy() {
        this.clearRect();
        if (this._textBox.parentNode) {
            this._textBox.parentNode.removeChild(this._textBox);
        }
    }

    fromJson(json) {
        this.clearRect();
        const data = JSON.parse(json);

        this._text = data.text;
        this._startTime = data.startTime;
        this._endTime = data.endTime;
        this._isDelete = data.isDelete;
    }

    toJson() {
        return JSON.stringify({
            text: this._text,
            startTime: this._startTime,
            endTime: this._endTime,
            isDelete: this._isDelete,
        });
    }
}

export default FJText;
